/**
 * Test IDs for QA automation.
 */
export const testIds = {
  noteFormAssociatedLocation: "note-form-associated-location",
  noteFormNoAssociatedLocation: "note-form-no-associated-location",
  noteFormAssociatedLocationOption: "note-form-associated-location-option",
  noteFormVisibility: "note-form-visibility",
  noteFormVisibilityOption: "note-form-visibility-option",
  noteFormNotesField: "note-form-notes-field",
} as const;
